import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1bcc70f6&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=1bcc70f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc70f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcc70f6')) {
      api.createRecord('1bcc70f6', component.options)
    } else {
      api.reload('1bcc70f6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1bcc70f6&scoped=true", function () {
      api.rerender('1bcc70f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/group/groupActivity/detail.vue"
export default component.exports